import React, { useState } from "react";
import { Link } from "react-router-dom";
import UserInfo from "../../Hooks/UserInfo";

export default function Sidebar({ isActive, setIsActive, setShow, show }) {
  const {
    categoriesPermission,
    tagPermission,
    faqPermission,
    supportPermission,
    notificationPermission,
    adminPermission,
  } = UserInfo();
  return (
    <aside>
      <div className="sidebar">
        {/* <div className="toggle-icon" onClick={() => setShow(!show)}>
          <img src={require("../../Assets/Images/toggle.svg").default} />
        </div> */}
        <div className="logo-side">
          <img className="small" src={require("../../Assets/Images/C.png")} />
          <img
            className="big"
            src={require("../../Assets/Images/main-logo.png")}
          />
        </div>
        <div className="side-menu">
          <div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/Dashboard"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/Dashboard"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="17"
                  viewBox="0 0 19 17"
                  fill="none"
                >
                  <path
                    d="M7.19785 15.655V10.655H11.1979V15.655C11.1979 16.205 11.6479 16.655 12.1979 16.655H15.1979C15.7479 16.655 16.1979 16.205 16.1979 15.655V8.655H17.8979C18.3579 8.655 18.5779 8.085 18.2279 7.785L9.86785 0.255C9.48785 -0.085 8.90785 -0.085 8.52785 0.255L0.167852 7.785C-0.172148 8.085 0.0378519 8.655 0.497852 8.655H2.19785V15.655C2.19785 16.205 2.64785 16.655 3.19785 16.655H6.19785C6.74785 16.655 7.19785 16.205 7.19785 15.655Z"
                    fill="#A3AED0"
                  />
                </svg>
                <p> Dashboard</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/ManageContent"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/ManageContent"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 10H7C7.55 10 8 9.55 8 9V1C8 0.45 7.55 0 7 0H1C0.45 0 0 0.45 0 1V9C0 9.55 0.45 10 1 10ZM1 18H7C7.55 18 8 17.55 8 17V13C8 12.45 7.55 12 7 12H1C0.45 12 0 12.45 0 13V17C0 17.55 0.45 18 1 18ZM11 18H17C17.55 18 18 17.55 18 17V9C18 8.45 17.55 8 17 8H11C10.45 8 10 8.45 10 9V17C10 17.55 10.45 18 11 18ZM10 1V5C10 5.55 10.45 6 11 6H17C17.55 6 18 5.55 18 5V1C18 0.45 17.55 0 17 0H11C10.45 0 10 0.45 10 1Z"
                    fill="#A3AED0"
                  />
                </svg>
                <p>Manage Content</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                to="/ManageSchools"
                className={
                  window.location.pathname == "/ManageSchools"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="17"
                  viewBox="0 0 20 17"
                  fill="none"
                >
                  <path
                    d="M3 14H7C8.65685 14 10 15.3431 10 17V7C10 4.17157 10 2.75736 9.12132 1.87868C8.24264 1 6.82843 1 4 1H3C2.05719 1 1.58579 1 1.29289 1.29289C1 1.58579 1 2.05719 1 3V12C1 12.9428 1 13.4142 1.29289 13.7071C1.58579 14 2.05719 14 3 14Z"
                    stroke="#A3AED0"
                    strokeWidth="2"
                  />
                  <path
                    d="M17 14H13C11.3431 14 10 15.3431 10 17V7C10 4.17157 10 2.75736 10.8787 1.87868C11.7574 1 13.1716 1 16 1H17C17.9428 1 18.4142 1 18.7071 1.29289C19 1.58579 19 2.05719 19 3V12C19 12.9428 19 13.4142 18.7071 13.7071C18.4142 14 17.9428 14 17 14Z"
                    stroke="#A3AED0"
                    strokeWidth="2"
                  />
                </svg>
                <p>Manage Schools</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                to="/school-stats"
                className={
                  window.location.pathname == "/school-stats"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M3 13.5V21H7.5V13.5H3ZM9.75 3V21H14.25V3H9.75ZM16.5 9V21H21V9H16.5Z"
                    stroke="#A3AED0"
                    strokeWidth="2"
                  />
                </svg>{" "}
                <p>School Stats</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/Teachers"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/Teachers"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="14"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V15C0 15.55 0.45 16 1 16H15C15.55 16 16 15.55 16 15V14C16 11.34 10.67 10 8 10Z"
                    fill="#A3AED0"
                  />
                </svg>
                <p>Teachers</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/Students"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/Students"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  id="Local-Library-Fill--Streamline-Outlined-Fill-Material"
                  height="24"
                  width="24"
                >
                  <path
                    fill="#a3aed0"
                    d="M12 22.5c-1.3 -1.15 -2.72085 -2.03335 -4.2625 -2.65 -1.54165 -0.61665 -3.120835 -0.925 -4.7375 -0.925V8.2c1.566665 0 3.12085 0.35835 4.6625 1.075 1.54165 0.71665 2.9875 1.71665 4.3375 3 1.35 -1.28335 2.79585 -2.28335 4.3375 -3 1.54165 -0.71665 3.09585 -1.075 4.6625 -1.075v10.725c-1.61665 0 -3.19585 0.30835 -4.7375 0.925 -1.54165 0.61665 -2.9625 1.5 -4.2625 2.65Zm0.075 -13.8c-1.08335 0 -1.99585 -0.37085 -2.7375 -1.1125 -0.74165 -0.74165 -1.1125 -1.65415 -1.1125 -2.7375 0 -1.083335 0.37085 -1.995835 1.1125 -2.7375C10.07915 1.370835 10.99165 1 12.075 1c1.08335 0 1.99585 0.370835 2.7375 1.1125C15.55415 2.854165 15.925 3.766665 15.925 4.85c0 1.08335 -0.37085 1.99585 -1.1125 2.7375 -0.74165 0.74165 -1.65415 1.1125 -2.7375 1.1125Z"
                    strokeWidth="0.5"
                  />
                </svg>
                <p>Students</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/Parents"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/Parents"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                  id="Supervisor-Account-Fill--Streamline-Outlined-Fill-Material"
                  height="20"
                  width="20"
                >
                  <path
                    fill="#a3aed0"
                    d="M2 20.0001v-2.375c0 -0.56665 0.15 -1.0875 0.45 -1.5625 0.3 -0.475 0.716665 -0.82915 1.25 -1.0625 1 -0.45 2.0265 -0.8125 3.0795 -1.0875 1.05315 -0.275 2.12665 -0.4125 3.2205 -0.4125 0.55 0 1.1 0.0389 1.65 0.11675 0.55 0.07765 1.1 0.1721 1.65 0.28325v1.325c-0.75 0.28335 -1.37085 0.74165 -1.8625 1.375 -0.49165 0.63335 -0.7375 1.35 -0.7375 2.15v1.25H2Zm10.2 0v-1.275c0 -0.3815 0.09165 -0.73525 0.275 -1.06125 0.18335 -0.32585 0.44165 -0.5804 0.775 -0.76375 0.6 -0.30835 1.22085 -0.5396 1.8625 -0.69375s1.30415 -0.23125 1.9875 -0.23125c0.68335 0 1.35 0.075 2 0.225 0.65 0.15 1.26665 0.38335 1.85 0.7 0.33335 0.16665 0.59165 0.4156 0.775 0.74675s0.275 0.6906 0.275 1.07825v1.275H12.2Zm4.9 -5.525c-0.658 0 -1.21415 -0.22715 -1.6685 -0.6815 -0.45435 -0.45435 -0.6815 -1.0105 -0.6815 -1.6685 0 -0.658 0.22715 -1.21415 0.6815 -1.6685 0.45435 -0.45435 1.0105 -0.6815 1.6685 -0.6815 0.658 0 1.21415 0.22715 1.6685 0.6815 0.45435 0.45435 0.6815 1.0105 0.6815 1.6685 0 0.658 -0.22715 1.21415 -0.6815 1.6685 -0.45435 0.45435 -1.0105 0.6815 -1.6685 0.6815Zm-7.1 -2.5c-1.05 0 -1.9375 -0.3625 -2.6625 -1.0875 -0.725 -0.725 -1.0875 -1.6125 -1.0875 -2.6625s0.3625 -1.9375 1.0875 -2.6625c0.725 -0.725 1.6125 -1.0875 2.6625 -1.0875s1.9375 0.3625 2.6625 1.0875c0.725 0.725 1.0875 1.6125 1.0875 2.6625s-0.3625 1.9375 -1.0875 2.6625c-0.725 0.725 -1.6125 1.0875 -2.6625 1.0875Z"
                    strokeWidth="0.5"
                  />
                </svg>
                <p>Parents</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/ManageCategories"
                    ? "menu-btn bar_active "
                    : "menu-btn "
                }
                style={{
                  opacity: !categoriesPermission ? "0.3" : "",
                }}
                to={!categoriesPermission ? undefined : "/ManageCategories"}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                  id="Fact-Check-Fill--Streamline-Outlined-Fill-Material"
                  height="20"
                  width="20"
                >
                  <path
                    fill="#a3aed0"
                    d="M3.299805 21c-0.4 0 -0.75 -0.15 -1.05 -0.45 -0.3 -0.3 -0.45 -0.65 -0.45 -1.05V4.5c0 -0.4 0.15 -0.75 0.45 -1.05 0.3 -0.3 0.65 -0.45 1.05 -0.45H20.6998c0.4 0 0.75 0.15 1.05 0.45 0.3 0.3 0.45 0.65 0.45 1.05v15c0 0.4 -0.15 0.75 -0.45 1.05 -0.3 0.3 -0.65 0.45 -1.05 0.45H3.299805Zm1.7 -4h4.999995v-2H4.999805v2Zm9.549995 -2 4.95 -4.95 -1.425 -1.425 -3.525 3.55 -1.425 -1.425 -1.4 1.425 2.825 2.825ZM4.999805 13h4.999995v-2H4.999805v2Zm0 -4h4.999995v-2H4.999805v2Z"
                    strokeWidth="0.5"
                  />
                </svg>
                <p>Manage Categories</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/ManageTags"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                style={{
                  opacity: !tagPermission ? "0.3" : "",
                }}
                to={!tagPermission ? undefined : "/ManageTags"}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                  id="Ballot-Fill--Streamline-Outlined-Fill-Material"
                  height="20"
                  width="20"
                >
                  <path
                    fill="#a3aed0"
                    d="M11.325 9.875h5.7v-1.5h-5.7v1.5Zm0 5.75h5.7v-1.5h-5.7v1.5Zm-2.625 -5.2c0.3575 0 0.6636 -0.12735 0.91825 -0.382 0.2545 -0.2545 0.38175 -0.5605 0.38175 -0.918 0 -0.3575 -0.12725 -0.6635 -0.38175 -0.918 -0.25465 -0.25465 -0.56075 -0.382 -0.91825 -0.382 -0.3575 0 -0.6636 0.12735 -0.91825 0.382 -0.2545 0.2545 -0.38175 0.5605 -0.38175 0.918 0 0.3575 0.12725 0.6635 0.38175 0.918 0.25465 0.25465 0.56075 0.382 0.91825 0.382Zm0 5.75c0.3575 0 0.6636 -0.12725 0.91825 -0.38175 0.2545 -0.25465 0.38175 -0.56075 0.38175 -0.91825 0 -0.3575 -0.12725 -0.6636 -0.38175 -0.91825 -0.25465 -0.2545 -0.56075 -0.38175 -0.91825 -0.38175 -0.3575 0 -0.6636 0.12725 -0.91825 0.38175 -0.2545 0.25465 -0.38175 0.56075 -0.38175 0.91825 0 0.3575 0.12725 0.6636 0.38175 0.91825 0.25465 0.2545 0.56075 0.38175 0.91825 0.38175ZM4.5 21c-0.4 0 -0.75 -0.15 -1.05 -0.45 -0.3 -0.3 -0.45 -0.65 -0.45 -1.05V4.5c0 -0.4 0.15 -0.75 0.45 -1.05C3.75 3.15 4.1 3 4.5 3h15c0.4 0 0.75 0.15 1.05 0.45 0.3 0.3 0.45 0.65 0.45 1.05v15c0 0.4 -0.15 0.75 -0.45 1.05 -0.3 0.3 -0.65 0.45 -1.05 0.45H4.5Z"
                    strokeWidth="0.5"
                  />
                </svg>
                <p>Manage Tags</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/FAQs"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                style={{
                  opacity: !faqPermission ? "0.3" : "",
                }}
                to={!faqPermission ? undefined : "/FAQs"}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                  id="Quick-Reference-Fill--Streamline-Outlined-Fill-Material"
                  height="20"
                  width="20"
                >
                  <path
                    fill="#a3aed0"
                    d="M15.875 20.25h1V16.5h-1v3.75Zm0.5 -4.725c0.13335 0 0.25 -0.05125 0.35 -0.15375 0.1 -0.1025 0.15 -0.2221 0.15 -0.35875 0 -0.13665 -0.05 -0.25625 -0.15 -0.35875 -0.1 -0.1025 -0.21665 -0.15375 -0.35 -0.15375 -0.15 0 -0.27085 0.05 -0.3625 0.15 -0.09165 0.1 -0.1375 0.2191 -0.1375 0.35725 0 0.138 0.04585 0.25885 0.1375 0.3625 0.09165 0.1035 0.2125 0.15525 0.3625 0.15525Zm0 6.45c-1.34185 0 -2.48565 -0.47285 -3.4315 -1.4185 -0.94565 -0.94585 -1.4185 -2.08965 -1.4185 -3.4315 0 -1.34185 0.47285 -2.48565 1.4185 -3.4315 0.94585 -0.94565 2.08965 -1.4185 3.4315 -1.4185 1.34185 0 2.48565 0.47285 3.4315 1.4185 0.94565 0.94585 1.4185 2.08965 1.4185 3.4315 0 1.34185 -0.47285 2.48565 -1.4185 3.4315 -0.94585 0.94565 -2.08965 1.4185 -3.4315 1.4185Zm-3.6 -13.825H17.5L12.775 3.5v4.65ZM4.5 22c-0.4125 0 -0.765585 -0.1469 -1.05925 -0.44075C3.146915 21.2656 3 20.9125 3 20.5V3.5c0 -0.4125 0.146915 -0.765665 0.44075 -1.0595C3.734415 2.146835 4.0875 2 4.5 2h9.025L19 7.475v3.875c-0.41665 -0.18335 -0.84725 -0.325 -1.29175 -0.425 -0.44435 -0.1 -0.88875 -0.15 -1.33325 -0.15 -0.7 0 -1.36665 0.10835 -2 0.325 -0.63335 0.21665 -1.21665 0.51665 -1.75 0.9h-5.65v1.5h4.175c-0.28335 0.4 -0.51165 0.835 -0.685 1.305 -0.17335 0.46985 -0.30335 0.9515 -0.39 1.445h-3.1v1.5h3.075c0.08335 0.83335 0.32085 1.61665 0.7125 2.35 0.39165 0.73335 0.90415 1.36665 1.5375 1.9H4.5Z"
                    strokeWidth="0.5"
                  />
                </svg>
                <p>FAQs</p>
              </Link>
            </div>
          </div>
          <div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/Support"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                style={{
                  opacity: !supportPermission ? "0.3" : "",
                }}
                to={!supportPermission ? undefined : "/Support"}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                  id="Smb-Share-Fill--Streamline-Outlined-Fill-Material"
                  height="20"
                  width="20"
                >
                  <path
                    fill="#a3aed0"
                    d="M11.425 13.25h4.525c0.4 0 0.74165 -0.14165 1.025 -0.425 0.28335 -0.28335 0.425 -0.625 0.425 -1.025 0 -0.4 -0.14165 -0.74585 -0.425 -1.0375 -0.28335 -0.29165 -0.625 -0.4375 -1.025 -0.4375h-0.3l-0.05 -0.25c-0.06665 -0.51665 -0.3 -0.95 -0.7 -1.3 -0.4 -0.35 -0.86665 -0.525 -1.4 -0.525 -0.43335 0 -0.83335 0.10835 -1.2 0.325 -0.36665 0.21665 -0.61665 0.51665 -0.75 0.9l-0.05 0.175h-0.2c-0.48335 0 -0.8875 0.17915 -1.2125 0.5375 -0.325 0.35835 -0.4875 0.77915 -0.4875 1.2625 0 0.48335 0.17915 0.90415 0.5375 1.2625 0.35835 0.35835 0.7875 0.5375 1.2875 0.5375ZM2.5 21c-0.4 0 -0.75 -0.15 -1.05 -0.45 -0.3 -0.3 -0.45 -0.65 -0.45 -1.05V5.25h1.5V19.5h18.25v1.5H2.5Zm3 -3c-0.4 0 -0.75 -0.15 -1.05 -0.45 -0.3 -0.3 -0.45 -0.65 -0.45 -1.05V3.5c0 -0.4 0.15 -0.75 0.45 -1.05 0.3 -0.3 0.65 -0.45 1.05 -0.45h6.5l1.5 1.5h8c0.4 0 0.75 0.15 1.05 0.45 0.3 0.3 0.45 0.65 0.45 1.05v11.5c0 0.4 -0.15 0.75 -0.45 1.05 -0.3 0.3 -0.65 0.45 -1.05 0.45H5.5Z"
                    strokeWidth="0.5"
                  />
                </svg>
                <p>Support</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/PushNotifications"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                style={{
                  opacity: !notificationPermission ? "0.3" : "",
                }}
                to={!notificationPermission ? undefined : "/PushNotifications"}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                  id="Doorbell-Fill--Streamline-Outlined-Fill-Material"
                  height="20"
                  width="20"
                >
                  <path
                    fill="#a3aed0"
                    d="M12 17.25c0.21665 0 0.40835 -0.07085 0.575 -0.2125 0.16665 -0.14165 0.26665 -0.32085 0.3 -0.5375h-1.75c0.03335 0.21665 0.13335 0.39585 0.3 0.5375s0.35835 0.2125 0.575 0.2125ZM8.125 16h7.75v-0.75h-1v-2.475c0 -0.71 -0.2 -1.3555 -0.6 -1.9365 -0.4 -0.581 -0.95 -0.95215 -1.65 -1.1135v-0.35c0 -0.1805 -0.05935 -0.32985 -0.178 -0.448 -0.1185 -0.118 -0.2685 -0.177 -0.45 -0.177 -0.18135 0 -0.33035 0.059 -0.447 0.177 -0.11665 0.11815 -0.175 0.2675 -0.175 0.448v0.35c-0.7 0.16135 -1.25 0.5325 -1.65 1.1135 -0.4 0.581 -0.6 1.2265 -0.6 1.9365v2.475h-1V16ZM4 21V9L12 3l8 6v12H4Z"
                    strokeWidth="0.5"
                  />
                </svg>
                <p>Push Notifications</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/strategy-packs"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to={"/strategy-packs"}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#a3aed0"
                >
                  <path d="m380-240 280-180-280-180v360ZM160-120q-33 0-56.5-23.5T80-200v-520h240v-80q0-33 23.5-56.5T400-880h160q33 0 56.5 23.5T640-800v80h240v520q0 33-23.5 56.5T800-120H160Zm0-80h640v-440H160v440Zm240-520h160v-80H400v80ZM160-200v-440 440Z" />
                </svg>
                <p>Strategy Packs</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/requests"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to={"/requests"}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#a3aed0"
                >
                  <path d="m691-150 139-138-42-42-97 95-39-39-42 43 81 81ZM240-600h480v-80H240v80ZM720-40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40ZM120-80v-680q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v267q-19-9-39-15t-41-9v-243H200v562h243q5 31 15.5 59T486-86l-6 6-60-60-60 60-60-60-60 60-60-60-60 60Zm120-200h203q3-21 9-41t15-39H240v80Zm0-160h284q38-37 88.5-58.5T720-520H240v80Zm-40 242v-562 562Z" />
                </svg>
                <p>Strategy Pack Requests</p>
              </Link>
            </div>
          </div>
          <div>
            <div className="side-btm-last">
              <div className="side-btm-space">
                <Link
                  className={
                    window.location.pathname == "/ManageAdmins"
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  style={{
                    opacity: !adminPermission ? "0.3" : "",
                  }}
                  to={!adminPermission ? undefined : "/ManageAdmins"}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 20"
                    id="Manage-Accounts-Fill--Streamline-Outlined-Fill-Material"
                    height="20"
                    width="20"
                  >
                    <path
                      fill="#a3aed0"
                      d="m16.675 21 -0.25 -1.65c-0.28335 -0.08335 -0.57085 -0.20415 -0.8625 -0.3625 -0.29165 -0.15835 -0.5375 -0.3375 -0.7375 -0.5375l-1.375 0.3 -0.625 -1.05L14 16.6c-0.03335 -0.15 -0.05 -0.35835 -0.05 -0.625s0.01665 -0.475 0.05 -0.625l-1.175 -1.1 0.625 -1.05 1.375 0.3c0.2 -0.2 0.44585 -0.37915 0.7375 -0.5375s0.57915 -0.27915 0.8625 -0.3625l0.25 -1.65h1.35l0.25 1.65c0.28335 0.08335 0.57085 0.20415 0.8625 0.3625 0.29165 0.15835 0.5375 0.3375 0.7375 0.5375l1.375 -0.3 0.625 1.05 -1.175 1.1c0.03335 0.15 0.05 0.35835 0.05 0.625s-0.01665 0.475 -0.05 0.625l1.175 1.1 -0.625 1.05 -1.375 -0.3c-0.2 0.2 -0.44585 0.37915 -0.7375 0.5375s-0.57915 0.27915 -0.8625 0.3625l-0.25 1.65h-1.35ZM2 19.9v-2.35c0 -0.58335 0.145835 -1.10835 0.4375 -1.575S3.15 15.15 3.7 14.9c1.2 -0.53335 2.3125 -0.91665 3.3375 -1.15 1.025 -0.23335 2.0125 -0.35 2.9625 -0.35h0.575c-0.35 0.85 -0.50835 1.97085 -0.475 3.3625 0.03335 1.39165 0.31665 2.4375 0.85 3.1375H2Zm15.35 -1.925c0.6 0 1.08335 -0.18335 1.45 -0.55 0.36665 -0.36665 0.55 -0.85 0.55 -1.45s-0.18335 -1.08335 -0.55 -1.45c-0.36665 -0.36665 -0.85 -0.55 -1.45 -0.55s-1.08335 0.18335 -1.45 0.55c-0.36665 0.36665 -0.55 0.85 -0.55 1.45s0.18335 1.08335 0.55 1.45c0.36665 0.36665 0.85 0.55 1.45 0.55ZM10 11.875c-1.1 0 -2 -0.35 -2.7 -1.05 -0.7 -0.7 -1.05 -1.6 -1.05 -2.7s0.35 -2 1.05 -2.7c0.7 -0.7 1.6 -1.05 2.7 -1.05s2 0.35 2.7 1.05c0.7 0.7 1.05 1.6 1.05 2.7s-0.35 2 -1.05 2.7c-0.7 0.7 -1.6 1.05 -2.7 1.05Z"
                      strokeWidth="0.5"
                    />
                  </svg>
                  <p>Manage Admins</p>
                </Link>
              </div>
              <div>
                <Link
                  className={
                    window.location.pathname == "/ChangePassword"
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/ChangePassword"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 21"
                    fill="none"
                  >
                    <path
                      d="M14 7H13V5C13 2.24 10.76 0 8 0C5.24 0 3 2.24 3 5V7H2C0.9 7 0 7.9 0 9V19C0 20.1 0.9 21 2 21H14C15.1 21 16 20.1 16 19V9C16 7.9 15.1 7 14 7ZM8 16C6.9 16 6 15.1 6 14C6 12.9 6.9 12 8 12C9.1 12 10 12.9 10 14C10 15.1 9.1 16 8 16ZM5 7V5C5 3.34 6.34 2 8 2C9.66 2 11 3.34 11 5V7H5Z"
                      fill="#A3AED0"
                    />
                  </svg>
                  <p>Change Password</p>
                </Link>
              </div>
              <div>
                <Link
                  className={
                    window.location.pathname == "/"
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  onClick={() => {
                    localStorage.clear();
                    window.location.href = "/";
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    id="Move-Group-Fill--Streamline-Outlined-Fill-Material"
                    height="24"
                    width="24"
                  >
                    <desc>
                      Move Group Fill Streamline Icon: https://streamlinehq.com
                    </desc>
                    <path
                      fill="#a3aed0"
                      d="M6.5 19c-0.4 0 -0.75 -0.15 -1.05 -0.45 -0.3 -0.3 -0.45 -0.65 -0.45 -1.05v-4h1.5v4h14V5H6.5v4h-1.5V3.5c0 -0.4 0.15 -0.75 0.45 -1.05 0.3 -0.3 0.65 -0.45 1.05 -0.45h14c0.4 0 0.75 0.15 1.05 0.45 0.3 0.3 0.45 0.65 0.45 1.05v14c0 0.4 -0.15 0.75 -0.45 1.05 -0.3 0.3 -0.65 0.45 -1.05 0.45H6.5Zm-3 3c-0.4 0 -0.75 -0.15 -1.05 -0.45 -0.3 -0.3 -0.45 -0.65 -0.45 -1.05V5h1.5v15.5h15.5v1.5H3.5Zm9 -6.6 -1.05 -1.05 2.325 -2.35H5v-1.5h8.775l-2.325 -2.35 1.05 -1.05 4.15 4.15 -4.15 4.15Z"
                      strokeWidth="0.5"
                    />
                  </svg>
                  <p>LogOut</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
